export enum CustomerTypes {
  COMPANY = 'Company',
  INDIVIDUAL = 'Individual',
}
